<kt-error [type]="type" [image]="image" [code]="code" [title]="title" [subtitle]="subtitle" [desc]="desc" [return]="return"></kt-error> p
